import Relatorios from '@/views/pages/relatorios/Relatorios'
import RelatorioPaciente from '@/views/pages/relatorios/paciente/RelatorioPaciente'
import RelatorioCobranca from '@/views/pages/relatorios/cobranca/RelatorioCobranca.vue'

export default [
    {
        path: '/relatorios',
        name: 'Relatorios',
        component: Relatorios,
        children: [
            {
                path: 'pacientes',
                name: 'RelatorioPaciente',
                component: RelatorioPaciente,
                meta: {
                    requiresAuth: true,
                    page: {
                        title: 'Relatórios',
                        subtitle: 'Pacientes'
                    },
                    containerProprio: false
                }
            },
            {
                path: 'cobrancas',
                name: 'RelatorioCobrancas',
                component: RelatorioCobranca,
                meta: {
                    requiresAuth: true,
                    page: {
                        title: 'Relatórios',
                        subtitle: 'Cobranças'
                    },
                    containerProprio: false
                }
            },
        ]
    },
]